import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { IHaloDropDown, textToDropDownData } from 'src/app/core/halo-dropdown/halo-dropdown.interface';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SuperFooterService } from 'src/app/core/services/super-footer.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-super-footer',
  templateUrl: './super-footer.component.html',
  styleUrls: ['./super-footer.component.scss'],
})
export class SuperFooterComponent implements OnInit, OnDestroy {
  public helpDropdownOptions: IHaloDropDown[] = [];
  public selectedForm: string | number | null = null;
  public footerAvailableCountry: string | null = null;
  public rootScopeData: RootScopeDeclare;
  public currentFacility: FacilityObject;

  @ViewChild('footerElement', { static: false }) footerElement: ElementRef;

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    public u: CommonUtil,
    private rootScopeService: RootScopeService,
    private superFooterService: SuperFooterService,
    private _facilityService: FacilityService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {}

  ngOnInit() {
    // create dropdown data
    this.helpDropdownOptions = textToDropDownData(
      [
        this.u.translateText('LF.CONNECT.QUESTION'),
        this.u.translateText('REQUEST.A.TECHNICIAN.VISIT'),
        this.u.translateText('EQUIPMENT.QUESTION'),
      ],
      true
    );

    /**
     * Super footer change events.
     */
    this.superFooterService.formSwitch.subscribe(
      (res: string) => {
        const selected = res ? { value: res, text: '' } : null;
        this.helpDropndownChanged(selected);
        this.scroll();
      },
      (err: any) => console.log(err)
    );

    this.rootScopeService.getRootScope().subscribe(
      (res) => {
        this.rootScopeData = res;
        this._checkCountry();
      },
      (err: any) => console.log(err)
    );

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this._checkCountry();
    });

    if (this.currentFacility['facilityId']) {
      this._checkCountry();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  _checkCountry() {
    this.rootScopeService.countryCheck(['US', 'ES', 'CA']).then(
      (res) => {
        this.footerAvailableCountry = res;
      },
      (err: any) => {
        this.footerAvailableCountry = null;
      }
    );
  }

  helpDropndownChanged(selected: IHaloDropDown | null) {
    this.selectedForm = selected ? selected.value : null;
  }

  openOrderParts() {
    this._amplitudeAnalytics.logEvent({ elementName: 'Order Parts', action: 'Click' }, 'Order Parts');
    if (localStorage.getItem('ssoFederated') != null && localStorage.getItem('ssoFederated') == 'true') {
      window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCAcpSSOLogin.jsp', '_blank');
    } else {
      window.open(environment.ssoPartsUrl + '/OA_HTML/ibeCZzpHome.jsp', '_blank');
    }
  }

  scroll() {
    setTimeout(() => {
      this.footerElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  onCall(tel: string) {
    this._amplitudeAnalytics.logEvent(
      { elementName: 'Phone', action: 'Call', additionalProperty: { phoneNumber: tel } },
      'Customer Service'
    );
  }
}
